export const LOGO_HOME = 'logotipo-muviflex.png'
export const BRAND_NAME = 'Muviflex'
export const ADRESS =
	'Rua Dona Teodora, 503 - Farrapos - Porto Alegre/RS CEP: 90.240-300'
export const COMPANY_NAME =
	'Movimento e Flexibilidade Desenvolvimento e Gerenciamento de Programa de Fidelização de Clientes Ltda. - CNPJ: 30.715.948/0001-94'
export const EMAIL = 'faleconosco@muviflex.com.br'
export const RATING_SITE_URL = 'https://www.reclameaqui.com.br/empresa/muviflex'
export const CHIPEST =
	'Sua viagem muito mais acessível. Aqui você encontrará a menor taxa do mercado e garantia do melhor preço. Explore novos destinos economizando!'
export const IS_DIGITAL =
	'Garantimos a melhor experiência de compra! Simplificamos a sua viagem desde a sua compra até o embarque. Apresente a passagem pelo celular no embarque!'
export const RELIBLE =
	'Nossa reputação inspira confiança. Ofertamos viagens de viações renomadas no mercado e devidamente regulamentadas.'
export const TRAVEL =
	'A cada viagem, exclusivamente da Planalto, você ganha pontos Muviflex que valem descontos, passagens grátis e muito mais!'
export const EASY_PURCHASE =
	'Pague com Cartão de crédito, Pix, Muvicard ou Pontos, a depender da regra da viação. Aqui você também encontra um atendimento excepcional!'
export const LOGO_LOADING = 'loading-logo-muviflex.png'
export const URL_HOME = 'muviflex.com.br'
export const TOKEN_HANDTALK = 'b49d4b88f0556bf283620506df65feb5'
export const META_PIXEL = '1225604122061497'
export const TIKTOK_PIXEL = ' '
export const PLATFORM = 1
export const AGENCY = 1
export const APP_ID = 10003
export const APP_DESCRIPTION = 'WEB MUVIFLEX'
export const FACEBOOK_LINK = 'https://www.facebook.com/muviflex'
export const INSTAGRAM_LINK = 'https://www.instagram.com/muviflex/'
export const APP_ANDROID_LINK =
	'https://play.google.com/store/apps/details?id=com.muviflex.app'
export const APP_IOS_LINK =
	'https://apps.apple.com/br/app/muviflex/id6753186360'
export const BANNER_APP_DESKTOP = 'muviflex/muviflex-banner-app-desktop.png'
export const BANNER_APP_MOBILE = 'muviflex/muviflex-banner-app-mobile.png'
// Item "Institucional" do menu: null abre a rota interna "Sobre nós" (routes.ABOUT)
export const INSTITUTIONAL_URL = null
